module.exports = __webpack_public_path__ + "static/media/logo.a6d4cf18.png";